import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import {
  flushPendingServerAnalyticsEvents,
  trackAnalyticsEvent,
  trackAnalyticsPageView,
} from "../analytics/analyticsClient";

export function useGaTracking(trackLocation?: boolean) {
  const location = useLocation();
  const lastTrackedPath = useRef<string>();

  useEffect(() => {
    flushPendingServerAnalyticsEvents();
  }, []);

  useEffect(() => {
    if (!trackLocation) return;

    if (lastTrackedPath.current === location.pathname + location.search) return;
    tracking.trackGaPageView();
    lastTrackedPath.current = location.pathname + location.search;
  }, [location]);

  const tracking = {
    trackGaPageView: () => {
      if (!import.meta.env.PROD) {
        console.info(
          "tracking.trackGaPageView",
          location.pathname + location.search,
        );
      }
      trackAnalyticsPageView(location.pathname + location.search);
    },
    removeThirdPartyGaId: (name: string) => {
      if (!import.meta.env.PROD) {
        console.info(
          "tracking.removeThirdPartyGaId (noop in Firebase-only tracking)",
          name,
        );
      }
    },
    addThirdPartyGaId: (name: string, gaId: string) => {
      if (!import.meta.env.PROD) {
        console.info(
          "tracking.addThirdPartyGaId (noop in Firebase-only tracking)",
          name,
          gaId,
        );
      }
    },
    trackGaEvent: (type: string, props: Record<string, unknown> = {}) => {
      trackAnalyticsEvent(type, props);
    },
  };

  return tracking;
}
